<template>
  <div>
    <h1>{{ tituloSorteio }}</h1>
    <b-row class="p-b-20">
      <b-col md="6" xl="6" sm="12">
        <b-button class="btn btn-danger float-right m-w" @click="goBack">Cancelar</b-button>
      </b-col>
      <b-col md="6" xl="6" sm="12">
        <b-button class="btn btn-success float-right m-w" @click="save" :disabled="!saveBtn">Salvar</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" v-if="imageSource != null && imageSource != ''">
        <b-card header="Imagem Atual">
          <img :src="imageSource" alt="Imagem da Sorteio" style="width:100%;" />
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card header="Editar Imagem">
          <picture-input
            ref="pictureInput"
            width="500"
            height="500"
            margin="16"
            accept="image/jpeg, image/png"
            size="10"
            :removable="true"
            button-class="changeBtn"
            removeButtonClass="removeBtn"
            :custom-strings="{
                            upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                            drag: 'Arraste uma imagem <br> (ou clique aqui)',
                            change: 'Mudar foto'
                          }"
            @change="onChange"
          ></picture-input>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "editarimagem",
  components: { PictureInput },
  data: function() {
    return {
      imageSource: null,
      tituloSorteio: null,
      saveBtn: false,
      selecionado: 2
    };
  },
  methods: {
    onChange(image) {
      if (image) {
        this.saveBtn = true;
        localStorage.setItem("image", image);
      } else {
        this.saveBtn = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    save() {
      axios
        .post(
          `${config.default.servidor}/gerencial/sorteio/imagem`,
          {
            empresaid: localStorage.getItem("enterprise_id").toString(),
            sorteioid: localStorage.getItem("id_sorteio").toString(),
            imagem: localStorage.getItem("image")
          },
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            let toast = this.$toasted.show("Sucesso!", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "check",
              iconPack: "fontawesome"
            });
          } else {
            let toast = this.$toasted.show("Algo deu errado.", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "times",
              iconPack: "fontawesome"
            });
          }
          this.$router.go(-1);
        })
        .catch(error => {
          let toast = this.$toasted.show("Algo deu errado.", {
            theme: "toasted-primary",
            position: "bottom-center",
            duration: 5000,
            icon: "times",
            iconPack: "fontawesome"
          });
        });
    },
    selecionar(selecionado) {
      this.selecionado = selecionado;
      if (selecionado == 1) {
        this.$refs.quadrado.classList.add("selecionado");
        this.$refs.vertical.classList.remove("selecionado");
        this.$refs.horizontal.classList.remove("selecionado");
      } else if (selecionado == 2) {
        this.$refs.quadrado.classList.remove("selecionado");
        this.$refs.vertical.classList.add("selecionado");
        this.$refs.horizontal.classList.remove("selecionado");
      } else {
        this.$refs.quadrado.classList.remove("selecionado");
        this.$refs.vertical.classList.remove("selecionado");
        this.$refs.horizontal.classList.add("selecionado");
      }
    }
  },
  beforeMount() {
    this.imageSource = localStorage.getItem("url_imagem").toString();
    this.tituloSorteio = localStorage.getItem("titulo_sorteio").toString();
  }
};
</script>
